export default class PaginationUtil {

    createSingleSortingParameter = sortingFields => {
        if (sortingFields) {
            const singleField = Array.isArray(sortingFields) ? sortingFields[0] : sortingFields;
            const direction = singleField.desc === true ? 'asc' : 'desc'; //for some reason the ReactTable sorting logic is inverted
            return `${singleField.id},${direction}`;
        }
    };
}